import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useQuery } from "../../util/useQuery";
import { setLeadData, setSalesRef } from "../state/signup.action";

const RSLR = 'rslr';
const SALES_REF = 'sales_ref';
const SPECIALIST_NAME = 'specialist_name';
const SPECIALIST_EMAIL = 'specialist_email';

export function useSignupQueryParams(dispatch: any) {
    const query = useQuery();
    const history = useHistory();

    const [ reseller, setReseller ] = useState<string>();

    useEffect(() => {
        const salesRef = query.get(SALES_REF) || undefined;
        if (salesRef) {
            dispatch(setSalesRef(salesRef));
        //    query.delete(SALES_REF);
        }
        const specialistName = query.get(SPECIALIST_NAME) || undefined;
        const specialistEmail = query.get(SPECIALIST_EMAIL) || undefined;
        const reseller = query.get(RSLR) || undefined;
        setReseller(reseller);
        if (specialistEmail || specialistName) {
            dispatch(setLeadData({
                specialist_email: specialistEmail,
                specialist_name: specialistName,
                reseller: reseller
            }))
            // query.delete(SPECIALIST_NAME);
            // query.delete(SPECIALIST_EMAIL);
        }
        history.replace({
            search: query.toString()
        })
        // eslint-disable-next-line
    }, []);

    return { reseller };
    
}